import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../components/Forms/PresetsTextField'
const EscalationOfCare = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <PresetsTextField
        fullWidth
        label="Escalation of Care"
        value={medPlan?.escalationOfCare}
        multiline
        suggestionPath="medPlan.escalationOfCare"
        suggestionLabel="Escalation notes from templates"
        setValue={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            escalationOfCare: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        autoComplete="off"
        name="medplan-escalationofcare"
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
  )
}

export default React.memo(EscalationOfCare)
